export default function () {
  let window = `relatorio.processos`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relatório de Processos',
    width: '800',
    height: '450',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./Processos.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
